import React from 'react';

import ConfigurationScreenWithTabs from '~/components/SystemConfiguration/ConfigurationScreenWithTabs';
import { ADMIN_ROUTES } from '~/routesConstants';

import GlobalCategoriesTab from './GlobalCategoriesTab';
import GlobalFieldsTab from './GlobalFieldsTab';
import { FNOL_PLACEMENTS, GLOBAL_FIELD_PLACEMENT } from './types';

const SUBTITLE =
  'Fields defined once for the organization and projected into every policy and FNOL configuration in their context. ' +
  'A configuration can see them but not edit them.';

const POLICY_DESCRIPTION =
  'Fields added to the policy form of every configuration in their context. They are also what a global category ' +
  'can condition on.';

const FNOL_DESCRIPTION =
  'Fields added to the FNOL form of every configuration in their context. Limit one to a global category to show it ' +
  "only when that category matches the claim's policy.";

const POLICY_PLACEMENTS = [GLOBAL_FIELD_PLACEMENT.Policy];

const PolicyFieldsTab: React.FC = () => (
  <GlobalFieldsTab placements={POLICY_PLACEMENTS} description={POLICY_DESCRIPTION} />
);

const FnolFieldsTab: React.FC = () => <GlobalFieldsTab placements={FNOL_PLACEMENTS} description={FNOL_DESCRIPTION} />;

const GlobalConfiguration: React.FC = () => {
  const tabs = [
    {
      label: 'Policy',
      url: ADMIN_ROUTES.GLOBAL_CONFIGURATION.POLICY,
      component: PolicyFieldsTab,
      isEnabled: true,
    },
    {
      label: 'FNOL',
      url: ADMIN_ROUTES.GLOBAL_CONFIGURATION.FNOL,
      component: FnolFieldsTab,
      isEnabled: true,
    },
    {
      label: 'Categories',
      url: ADMIN_ROUTES.GLOBAL_CONFIGURATION.CATEGORIES,
      component: GlobalCategoriesTab,
      isEnabled: true,
    },
  ];

  return (
    <ConfigurationScreenWithTabs
      tabs={tabs}
      title="GLOBAL CONFIGURATION"
      subtitle={SUBTITLE}
      operationTabName="Global Configuration"
    />
  );
};

export default GlobalConfiguration;
